/**
 * Storefront Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './app/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);

